import { IHoliday } from '../Client/IHoliday'

export const GET_HOLIDAYS = 'GET_HOLIDAYS'
export const GET_HOLIDAYS_SUCCESS = 'GET_HOLIDAYS_SUCCESS'
export const GET_HOLIDAYS_FAILURE = 'GET_HOLIDAYS_FAILURE'

interface GetHolidaysAction {
  type: typeof GET_HOLIDAYS
}

interface GetHolidaysSuccessAction {
  type: typeof GET_HOLIDAYS_SUCCESS
  payload: {
    holidays: IHoliday[]
  }
}

interface GetHolidaysFailureAction {
  type: typeof GET_HOLIDAYS_FAILURE
}

export type TActionTypes =
  | GetHolidaysAction
  | GetHolidaysSuccessAction
  | GetHolidaysFailureAction
